module.exports = __webpack_public_path__ + "img/devbox32.6678e5fe.png";